import { Space } from '@shure/cloud/shared/models/devices';

import { SpaceFragment } from '../graphql/generated/cloud-sys-api';

export function mapSpaceFromSysApi(space: SpaceFragment | null | undefined): Space | undefined {
	if (!space) {
		return undefined;
	}

	return {
		id: space.id,
		name: space.name,
		creationDate: new Date(space.createdAt),
		groupId: space.group?.id,
		health: {
			worstSeverity: space.health.worstSeverity ?? undefined
		}
	};
}
